import type { JacintaMemoryEntry } from '@/modules/shared/types/yc-demo';
import { useJacintaMemory } from '@/modules/brain/store/memoryStore';

/**
 * Thin pass-through to Plan 05's Zustand memory store. Reading/writing through
 * `getState()` keeps non-React callers (e.g. async save handlers) able to
 * push entries while React subscribers reactively re-render.
 *
 * Plan 05 owns the store implementation; this module exists so the reports
 * code has a single import target and can swap to a different consumer later
 * (e.g. a server-backed store) without touching every callsite.
 */
export function addJacintaMemory(entry: JacintaMemoryEntry) {
    useJacintaMemory.getState().addMemory(entry);
}
